import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts'

/**
 * Admin emails allowed to access admin routes
 * In the future, this can be moved to database roles
 */
const ADMIN_EMAILS = ['evgen.galakhov@gmail.com']

/**
 * Check if a user is an admin
 */
// eslint-disable-next-line react-refresh/only-export-components
export function isAdmin(email: string | undefined): boolean {
  if (!email) return false
  return ADMIN_EMAILS.includes(email.toLowerCase())
}

/**
 * Route guard for admin-only routes
 * Redirects non-admin users to dashboard
 */
export function AdminGuard() {
  const { user, isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isAdmin(user?.email)) {
    // Non-admin users get redirected to dashboard
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
